export function plus(a, b) {
  return a + b;
}
export function capitalizeFirstLetter(string) {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export function canEditNews() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit news");
}
export function canEditClasses() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit classes");
}

export function canEditSessions() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit sessions");
}

export function canEditUsers() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit users");
}

export function canEditInstructors() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit instructors");
}

export function canEditReviews() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit reviews");
}

export function canEditPackages() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit packages");
}

export function canEditMemberships() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("edit memberships");
}

export function canViewReports() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view reports");
}

export function canViewNews() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view news");
}

export function canViewClasses() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view classes");
}

export function canViewSessions() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view sessions");
}

export function canViewUsers() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view users");
}

export function canViewInstructors() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view instructors");
}

export function canViewReviews() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view reviews");
}

export function canViewPackages() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view packages");
}

export function canViewMemberships() {
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  return permissions.includes("view memberships");
}
